var text_field_default = {
  "root": "wAQCX",
  "text": "V-kc7",
  "input": "MwAG3",
  "small": "BDBid",
  "medium": "hFEnL",
  "large": "-aJxc",
  "webview": "_9M09g",
  "endAdornment": "WkH5u",
  "shown": "_1rQkL",
  "value": "enBUl",
  "spinner": "p80yI",
  "spin": "_3yX1L"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
